const initState = {
    create:{
        result:false,
        /**control */
        connection: false,
        error: false,
        message: "",
    }
};

export default initState;